import React from 'react';
import { MenuItem, SelectChangeEvent } from '@mui/material';
import {
  DataTypeOption,
  DataTypesAPIResponse,
  FIELD_DATA_TYPE_CONFIG_DEFAULT,
  FIELD_THOUSANDS_GROUPING_DEFAULT,
  getCompositeFormatKey,
} from '../fields/FieldsSettings/FieldsSettingsTypes';
import { SelectFormControl, InputLabelDataType } from '../tool/fieldModal/FieldStyles';
import { getDataUIlabels } from '../../utils/getDataUIlabels';

interface DataFormatSelectProps {
  dataFormat?: DataTypeOption | null;
  dataType?: string;
  dataTypesResponse?: DataTypesAPIResponse[];
  fieldId: string;
  handleDataFormatChange: (event: SelectChangeEvent<unknown>) => void;
  haveTitle?: boolean;
  readOnly?: boolean;
}

const DataFormatSelect: React.FC<DataFormatSelectProps> = ({
  dataFormat,
  dataType,
  dataTypesResponse,
  fieldId,
  handleDataFormatChange,
  haveTitle = true,
  readOnly,
}) => {
  const uiLabels = getDataUIlabels(dataType, dataTypesResponse);
  const options = Object.keys(uiLabels);

  // Compute the current value based on data type
  const getCurrentValue = () => {
    if (dataType === 'date') {
      return dataFormat?.order || '';
    }
    if (dataType === 'amount' || dataType === 'number') {
      // Return composite key for amount/number
      const decimalSymbol =
        dataFormat?.decimalSymbol || FIELD_DATA_TYPE_CONFIG_DEFAULT[dataType] || '.';
      const thousandsGrouping = dataFormat?.thousandsGrouping || FIELD_THOUSANDS_GROUPING_DEFAULT;
      return getCompositeFormatKey(decimalSymbol, thousandsGrouping);
    }
    return '';
  };

  return (
    <>
      {haveTitle && <InputLabelDataType id="data-type-label">Data Format</InputLabelDataType>}

      <SelectFormControl
        data-cy="data-format-selector"
        disabled={readOnly}
        fullWidth
        id="data-format-selector"
        labelId="data-format-label"
        name="dataFormat"
        onChange={handleDataFormatChange}
        value={getCurrentValue()}
      >
        {options.map((option) => (
          <MenuItem key={`${fieldId}-${option}`} value={option} data-cy="data-format-selector-item">
            {uiLabels[option]}
          </MenuItem>
        ))}
      </SelectFormControl>
    </>
  );
};

export default DataFormatSelect;
